import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { cloneDeep, isEmpty } from 'lodash';
import moWelfare from '../store/wealfare';
import { LinearProgress } from '@mui/material';

interface IProps { }
interface IState { }

const MapTopRanking = (props: IProps, state: IState) => {
  const { WelfareCityRankDate, activeCity } = moWelfare;
  const [active, setActive] = useState<number>(-1);
  useEffect(() => {
    return () => { };
  }, []);
  const getArrayIndex = (arr: any, obj: any) => {
    if (obj) {
      let i = arr.length;
      while (i--) {
        if (obj.includes(arr[i].city) ||
          obj.includes(arr[i].city_grade) || obj.includes(arr[i].city_region)) {
          return i;
        }
      }
    }
    return '';
  };
  useEffect(() => {
    if (!isEmpty(WelfareCityRankDate)) {
      setActive(getArrayIndex(WelfareCityRankDate, activeCity));
    }
  }, [activeCity]);

  const getMax = () => {
    const result: any = cloneDeep(WelfareCityRankDate);
    if (result.length > 0) {
      const list = result?.sort((a: any, b: any) => b.amount - a.amount);
      return list[0].amount;
    }
    return 1000;
  };

  const normalise = (value: any) => (value / getMax());
  return (
    <section className="welfare-top-ranking-001">
      <span className="sub-title">排行</span>
      <p>单位（人民币 CNY）</p>
      {
        WelfareCityRankDate?.slice(0, 10)?.map((item: any, i: any) => (
          <section
            className={active !== i ? 'map-top-ranking-content-005' : 'map-top-ranking-content-008'}
            key={i.toString()}
            onMouseEnter={() => setActive(i)}
            onMouseLeave={() => setActive(-1)}>
            <span className="map-item-008"
              style={{ width: '35px' }}>
              {item.city}
            </span>
            <p className="map-top-progress-001">
              <LinearProgress
                variant="buffer" value={normalise(item.amount * 100)} valueBuffer={0} />
            </p>
            <span className="up-item-009">{Number(item.amount).toLocaleString()}</span>
          </section>
        ))
      }
    </section>
  );
};

export default observer(MapTopRanking);
